import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type StatusFilterType = "all" | "actionRequired" | "existing" | "expired" | null

const initialState = {
  statusFilter: null as StatusFilterType,
}

export const dashboardFiltersSlice = createSlice({
  name: "dashboardFilters",
  initialState,
  reducers: {
    setStatusFilter: (state, action: PayloadAction<StatusFilterType>) => {
      state.statusFilter = action.payload
    },
  },
})

export const { setStatusFilter } = dashboardFiltersSlice.actions

export default dashboardFiltersSlice.reducer
